// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"359":"94d3b8e4","890":"16e0fd92"}[chunkId] + ".css";
};